<h1 class="header">
    404 - page not found
</h1>
<h3>
    <a routerLink="/search">go to main page</a>
</h3>